<tt-page *ngIf="valid && page">
    <tt-card *ngIf="showSearchField || showScanField" class="col-xs-12 sp-0">
        <tt-input *ngIf="showSearchField" ttLabel="searchtext" [ttModel]="scanValue" (ttModelChange)="onSearchChanged($event)"></tt-input>
        <tt-input *ngIf="showScanField" #scanInput ttLabelView="none" ttBindFocus [ttModel]="scanValue" (ttModelChange)="onScanChanged($event)"></tt-input>
    </tt-card>
    <div class="production-content" [class.production-content--split]="showGrid && showReport">
        <div *ngIf="grid" [style.width.%]="showReport ? gridWidth : 100">
            <tt-grid [ttOptions]="grid" (ttReady)="onGridReady($event)">
                <ng-container toolbarButtons>
                    <tt-button *ngFor="let button of buttons" [ttText]="button.text" [ttIcon]="button.icon" [ttType]="button.cssclass?.includes('danger') ? 'danger' : button.cssclass?.includes('success') ? 'success' : 'primary'" [ttLoading]="busyButton === button.name" [ttDisabled]="!!busyButton && busyButton !== button.name" (ttClick)="runButton(button)"></tt-button>
                    <span class="production-title">{{ page.menu?.menuname?.slice(0, 50) }}</span>
                </ng-container>
            </tt-grid>
        </div>
        <iframe *ngIf="showReport" title="Production report" [src]="previewLink" [style.height.px]="height"></iframe>
    </div>
</tt-page>
